<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { parseTime } from '@/utils/common'
import { getSubPage } from '@/api/pageData'
import { getLinearColor } from '@/utils/modules/getStyles'

export default {
  name: 'DialogId4',
  components: { ModuleTitle },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      nowYear: ''
    }
  },
  created() {
    this.initPageData()
  },
  mounted() {
    const now = new Date()
    this.nowYear = parseTime(now, '{y}')
  },
  methods: {
    getLinearColor,
    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list
        }
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-4">
    <div class="title-container">
      <module-title :title="currentModule.title" :margi-bottom="40" />
    </div>
    <div class="dialog-container">
      <el-image class="line" :src="require('imgs/modules/dialog-modules/id-4-line.png')" alt="line" />
      <div class="group-container">
        <div
          v-for="(v, i) in pageData"
          :key="`dialog-id8-${i}`"
          class="item"
        >
          <div class="title-box">
            <p
              class="item-order"
              :style="{background: `linear-gradient(95deg, ${getLinearColor(path)[0]}, ${getLinearColor(path)[1]})`}"
            >
              {{ i + 1 }}
            </p>
            <p class="title">{{ v.headline }}</p>
          </div>
          <p class="memo" v-html="v.memo"></p>
        </div>
      </div>
    </div>
  </div>
</template>

  <style lang="scss" scoped>
  // 1330
  .dialog-id-4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title-container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
    }
    .dialog-container {
      width: 957px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .line {
        width: 957px;
        height: 25px;
      }
    }
  }
  .group-container {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: center;
    row-gap: 40px;
    width: 914px;
    background-color: #fafafa;
    padding: 14px 22px 30px;
    box-sizing: border-box;
    height: 570px;
    overflow-y: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
.title-box {
  width: 870px;
  display: flex;
  align-items: center;
  column-gap: 16px;
  .item-order {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // background: linear-gradient(95deg, #46A25E, #60B642);
    border-radius: 5px;

    font-size: 24px;
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
  }
  .title {
    flex: 1;
    font-size: 17px;
    font-weight: 800;
    color: #000;
  }
}
.memo {
  width: 870px;
  background: #F1F1F1;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 16px;
  color: #000;
  line-height: 29px;
  margin-top: 20px;
}
</style>
